import {Component} from '@angular/core';
import { AppComponent } from 'src/app/app.component';

@Component({
	selector: 'app-page-work-in-progress',
	templateUrl: './page-work-in-progress.component.html',
	styles: `
		img {
			-webkit-user-drag: none;
			user-drag: none;
		}
	`
})

export class PageWorkInProgressComponent {
	constructor(
		public app: AppComponent,
	) {}

	getMenuTheme(): string {
		return this.app.menuTheme;
	}
}
